<template>
  <div>
    <div class="common-form">添加音乐</div>
    <el-form ref="form" :model="form" label-width="200px">
      <el-form-item label="音乐名称">
        <el-input class="max-w460" v-model="form.name"></el-input>
      </el-form-item>
      <el-form-item label="是否显示">
        <el-radio-group v-model="form.is_show">
          <el-radio :label="1">是</el-radio>
          <el-radio :label="0">否</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="音乐图片：" :rules="[{ required: true, message: '请上传音乐图片' }]" prop="imageId">
        <el-row>
          <div class="draggable-list">
            <div class="item img-select" v-if="form.imageId==0" @click="openProductUpload('image', 'music_image')">
              <i class="el-icon-plus"></i>
            </div>
            <div v-if="form.imageId!=0" class="item" @click="openProductUpload('image', 'music_image')">
              <img :src="filePath" width="100" height="100" />
            </div>
          </div>
        </el-row>
      </el-form-item>

      <el-form-item label="音频：">
        <el-row>
          <div class="draggable-list">
            <div class="item img-select" v-if="form.file_address==''" @click="openProductUpload('audio', 'audio')">
              <i class="el-icon-plus"></i>
            </div>
            <div v-if="form.file_address!=0">
              <audio width="150" height="150" :src="form.file_address" :autoplay="false" controls></audio>
              <div>
                <el-button @click="delAudio">删除音频</el-button>
              </div>
            </div>
          </div>
        </el-row>
      </el-form-item>
      <el-form-item label="音频描述">
        <el-input class="max-w460" v-model="form.desc"></el-input>
      </el-form-item>
      <el-form-item label="排序">
        <el-input class="max-w460" v-model="form.music_sort" type="number"></el-input>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="onSubmit">立即添加</el-button>

      </el-form-item>
    </el-form>
    <!--图片组件-->
    <Upload v-if="isProductUpload" :config="config" :isupload="isProductUpload" @returnImgs="returnProductImgsFunc">上传图片</Upload>
  </div>
</template>

<script>
import MusicApi from "@/api/music.js";
import Upload from "@/components/file/Upload";
export default {
  components: {
    Upload
  },
  data() {
    return {
      form: {
        is_show: 1,
        name: "",
        music_sort: 100,
        desc: "",
        file_address: "",
        imageId: ""
      },
      audio_url: "",
      filePath: "",
      isProductUpload: false,
      file_name: "image"
    };
  },
  created() {},

  methods: {
    /*打开上传图片*/
    openProductUpload: function(fileType, file_name) {
      this.file_name = file_name;
      if (fileType == "image") {
        this.config = {
          total: 1,
          fileType: "image"
        };
      } else if (fileType == "audio") {
        this.config = {
          total: 1,
          fileType: "audio"
        };
      } else {
        this.config = {
          total: 1,
          fileType: "video"
        };
      }
      this.isProductUpload = true;
    },
    /*上传活动图片*/
    returnProductImgsFunc(e) {
      if (e != null) {
        if (this.file_name == "audio") {
          this.form.file_address = e[0].filePath;
          // this.audio_url = e[0].filePath;
        } else if (this.file_name == "music_image") {
          this.form.imageId = e[0].fileId;
          this.filePath = e[0].filePath;
        }
      }
      this.isProductUpload = false;
    },
    // 删除音频
    delAudio() {
      this.form.file_address = "";
      this.audio_url = "";
    },
    onSubmit() {
      let self = this;
      self.$refs.form.validate(valid => {
        if (valid) {
          MusicApi.MusicAdd(self.form, true)
            .then(data => {
              self.$message({
                message: "添加成功",
                type: "success"
              });
              self.from = {
                is_show: 1,
                name: "",
                music_sort: 100,
                desc: ""
              };
              self.$router.push("/music/music/index");
              // Technician
            })
            .catch(error => {});
        }
      });
    }
  }
};
</script>




<style>
.edit_container {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  line-height: 20px;
  color: #2c3e50;
}

.ql-editor {
  height: 400px;
}

.draggable-list {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.draggable-list .wrapper > span {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.draggable-list .item {
  position: relative;
  width: 110px;
  height: 110px;
  margin-top: 10px;
  margin-right: 10px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #dddddd;
}

.draggable-list .delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  background: red;
  line-height: 16px;
  font-size: 16px;
  color: #ffffff;
  display: none;
}

.draggable-list .item:hover .delete-btn {
  display: block;
}

.draggable-list .item img {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  max-height: 100%;
  max-width: 100%;
}

.draggable-list .img-select {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px dashed #dddddd;
  font-size: 30px;
}

.draggable-list .img-select i {
  color: #409eff;
}
</style>



// WEBPACK FOOTER //
// src/views/music/music/add.vue